/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as LocaleRouteRouteImport } from './routes/$locale/route'
import { Route as LocaleIndexRouteImport } from './routes/$locale/index'
import { Route as LocaleUserIdRouteRouteImport } from './routes/$locale/$userId/route'
import { Route as LocaleForgotPasswordIndexRouteImport } from './routes/$locale/forgot-password/index'
import { Route as LocaleQuizPlayerProjectIdRouteRouteImport } from './routes/$locale/quiz-player/$projectId/route'
import { Route as LocaleRecoveryIndexRouteImport } from './routes/$locale/recovery/index'
import { Route as LocaleSigninIndexRouteImport } from './routes/$locale/signin/index'
import { Route as LocaleSignupIndexRouteImport } from './routes/$locale/signup/index'
import { Route as LocaleVerifyEmailIndexRouteImport } from './routes/$locale/verify-email/index'
import { Route as LocaleUserIdProjectsIndexRouteImport } from './routes/$locale/$userId/projects/index'
import { Route as LocaleUserIdProjectsProjectIdRouteRouteImport } from './routes/$locale/$userId/projects/$projectId/route'
import { Route as LocaleExamTokenIndexRouteImport } from './routes/$locale/exam/$token/index'
import { Route as LocaleUserIdProfileCertificatesIndexRouteImport } from './routes/$locale/$userId/profile/certificates/index'
import { Route as LocaleUserIdProfileMeIndexRouteImport } from './routes/$locale/$userId/profile/me/index'
import { Route as LocaleUserIdProfileSettingsIndexRouteImport } from './routes/$locale/$userId/profile/settings/index'
import { Route as LocaleLiveSessionIdTeamIdIndexRouteImport } from './routes/$locale/live/$sessionId/$teamId/index'
import { Route as LocaleLiveSessionIdHostIndexRouteImport } from './routes/$locale/live/$sessionId/host/index'
import { Route as LocaleQuizPlayerProjectIdQuestionnairesIndexRouteImport } from './routes/$locale/quiz-player/$projectId/questionnaires/index'
import { Route as LocaleQuizPlayerProjectIdWelcomeIndexRouteImport } from './routes/$locale/quiz-player/$projectId/welcome/index'
import { Route as LocaleUserIdProjectsProjectIdCertificatesIndexRouteImport } from './routes/$locale/$userId/projects/$projectId/certificates/index'
import { Route as LocaleUserIdProjectsProjectIdDashboardIndexRouteImport } from './routes/$locale/$userId/projects/$projectId/dashboard/index'
import { Route as LocaleUserIdProjectsProjectIdQuestionnaireIndexRouteImport } from './routes/$locale/$userId/projects/$projectId/questionnaire/index'
import { Route as LocaleUserIdProjectsProjectIdQuestionsIndexRouteImport } from './routes/$locale/$userId/projects/$projectId/questions/index'
import { Route as LocaleUserIdProjectsProjectIdSettingsIndexRouteImport } from './routes/$locale/$userId/projects/$projectId/settings/index'
import { Route as LocaleQuizPlayerProjectIdLiveSessionIdIndexRouteImport } from './routes/$locale/quiz-player/$projectId/live/$sessionId/index'
import { Route as LocaleQuizPlayerProjectIdQuestionnairesQuestionnaireIdIndexRouteImport } from './routes/$locale/quiz-player/$projectId/questionnaires/$questionnaireId/index'
import { Route as LocaleUserIdProjectsProjectIdQuestionnaireQuestionnaireIdIndexRouteImport } from './routes/$locale/$userId/projects/$projectId/questionnaire/$questionnaireId/index'
import { Route as LocaleQuizPlayerProjectIdQuestionnairesQuestionnaireIdQuestionIdIndexRouteImport } from './routes/$locale/quiz-player/$projectId/questionnaires/$questionnaireId/$questionId/index'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const LocaleRouteRoute = LocaleRouteRouteImport.update({
  id: '/$locale',
  path: '/$locale',
  getParentRoute: () => rootRouteImport,
} as any)
const LocaleIndexRoute = LocaleIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LocaleRouteRoute,
} as any)
const LocaleUserIdRouteRoute = LocaleUserIdRouteRouteImport.update({
  id: '/$userId',
  path: '/$userId',
  getParentRoute: () => LocaleRouteRoute,
} as any)
const LocaleForgotPasswordIndexRoute =
  LocaleForgotPasswordIndexRouteImport.update({
    id: '/forgot-password/',
    path: '/forgot-password/',
    getParentRoute: () => LocaleRouteRoute,
  } as any)
const LocaleQuizPlayerProjectIdRouteRoute =
  LocaleQuizPlayerProjectIdRouteRouteImport.update({
    id: '/quiz-player/$projectId',
    path: '/quiz-player/$projectId',
    getParentRoute: () => LocaleRouteRoute,
  } as any)
const LocaleRecoveryIndexRoute = LocaleRecoveryIndexRouteImport.update({
  id: '/recovery/',
  path: '/recovery/',
  getParentRoute: () => LocaleRouteRoute,
} as any)
const LocaleSigninIndexRoute = LocaleSigninIndexRouteImport.update({
  id: '/signin/',
  path: '/signin/',
  getParentRoute: () => LocaleRouteRoute,
} as any)
const LocaleSignupIndexRoute = LocaleSignupIndexRouteImport.update({
  id: '/signup/',
  path: '/signup/',
  getParentRoute: () => LocaleRouteRoute,
} as any)
const LocaleVerifyEmailIndexRoute = LocaleVerifyEmailIndexRouteImport.update({
  id: '/verify-email/',
  path: '/verify-email/',
  getParentRoute: () => LocaleRouteRoute,
} as any)
const LocaleUserIdProjectsIndexRoute =
  LocaleUserIdProjectsIndexRouteImport.update({
    id: '/projects/',
    path: '/projects/',
    getParentRoute: () => LocaleUserIdRouteRoute,
  } as any)
const LocaleUserIdProjectsProjectIdRouteRoute =
  LocaleUserIdProjectsProjectIdRouteRouteImport.update({
    id: '/projects/$projectId',
    path: '/projects/$projectId',
    getParentRoute: () => LocaleUserIdRouteRoute,
  } as any)
const LocaleExamTokenIndexRoute = LocaleExamTokenIndexRouteImport.update({
  id: '/exam/$token/',
  path: '/exam/$token/',
  getParentRoute: () => LocaleRouteRoute,
} as any)
const LocaleUserIdProfileCertificatesIndexRoute =
  LocaleUserIdProfileCertificatesIndexRouteImport.update({
    id: '/profile/certificates/',
    path: '/profile/certificates/',
    getParentRoute: () => LocaleUserIdRouteRoute,
  } as any)
const LocaleUserIdProfileMeIndexRoute =
  LocaleUserIdProfileMeIndexRouteImport.update({
    id: '/profile/me/',
    path: '/profile/me/',
    getParentRoute: () => LocaleUserIdRouteRoute,
  } as any)
const LocaleUserIdProfileSettingsIndexRoute =
  LocaleUserIdProfileSettingsIndexRouteImport.update({
    id: '/profile/settings/',
    path: '/profile/settings/',
    getParentRoute: () => LocaleUserIdRouteRoute,
  } as any)
const LocaleLiveSessionIdTeamIdIndexRoute =
  LocaleLiveSessionIdTeamIdIndexRouteImport.update({
    id: '/live/$sessionId/$teamId/',
    path: '/live/$sessionId/$teamId/',
    getParentRoute: () => LocaleRouteRoute,
  } as any)
const LocaleLiveSessionIdHostIndexRoute =
  LocaleLiveSessionIdHostIndexRouteImport.update({
    id: '/live/$sessionId/host/',
    path: '/live/$sessionId/host/',
    getParentRoute: () => LocaleRouteRoute,
  } as any)
const LocaleQuizPlayerProjectIdQuestionnairesIndexRoute =
  LocaleQuizPlayerProjectIdQuestionnairesIndexRouteImport.update({
    id: '/questionnaires/',
    path: '/questionnaires/',
    getParentRoute: () => LocaleQuizPlayerProjectIdRouteRoute,
  } as any)
const LocaleQuizPlayerProjectIdWelcomeIndexRoute =
  LocaleQuizPlayerProjectIdWelcomeIndexRouteImport.update({
    id: '/welcome/',
    path: '/welcome/',
    getParentRoute: () => LocaleQuizPlayerProjectIdRouteRoute,
  } as any)
const LocaleUserIdProjectsProjectIdCertificatesIndexRoute =
  LocaleUserIdProjectsProjectIdCertificatesIndexRouteImport.update({
    id: '/certificates/',
    path: '/certificates/',
    getParentRoute: () => LocaleUserIdProjectsProjectIdRouteRoute,
  } as any)
const LocaleUserIdProjectsProjectIdDashboardIndexRoute =
  LocaleUserIdProjectsProjectIdDashboardIndexRouteImport.update({
    id: '/dashboard/',
    path: '/dashboard/',
    getParentRoute: () => LocaleUserIdProjectsProjectIdRouteRoute,
  } as any)
const LocaleUserIdProjectsProjectIdQuestionnaireIndexRoute =
  LocaleUserIdProjectsProjectIdQuestionnaireIndexRouteImport.update({
    id: '/questionnaire/',
    path: '/questionnaire/',
    getParentRoute: () => LocaleUserIdProjectsProjectIdRouteRoute,
  } as any)
const LocaleUserIdProjectsProjectIdQuestionsIndexRoute =
  LocaleUserIdProjectsProjectIdQuestionsIndexRouteImport.update({
    id: '/questions/',
    path: '/questions/',
    getParentRoute: () => LocaleUserIdProjectsProjectIdRouteRoute,
  } as any)
const LocaleUserIdProjectsProjectIdSettingsIndexRoute =
  LocaleUserIdProjectsProjectIdSettingsIndexRouteImport.update({
    id: '/settings/',
    path: '/settings/',
    getParentRoute: () => LocaleUserIdProjectsProjectIdRouteRoute,
  } as any)
const LocaleQuizPlayerProjectIdLiveSessionIdIndexRoute =
  LocaleQuizPlayerProjectIdLiveSessionIdIndexRouteImport.update({
    id: '/live/$sessionId/',
    path: '/live/$sessionId/',
    getParentRoute: () => LocaleQuizPlayerProjectIdRouteRoute,
  } as any)
const LocaleQuizPlayerProjectIdQuestionnairesQuestionnaireIdIndexRoute =
  LocaleQuizPlayerProjectIdQuestionnairesQuestionnaireIdIndexRouteImport.update(
    {
      id: '/questionnaires/$questionnaireId/',
      path: '/questionnaires/$questionnaireId/',
      getParentRoute: () => LocaleQuizPlayerProjectIdRouteRoute,
    } as any,
  )
const LocaleUserIdProjectsProjectIdQuestionnaireQuestionnaireIdIndexRoute =
  LocaleUserIdProjectsProjectIdQuestionnaireQuestionnaireIdIndexRouteImport.update(
    {
      id: '/questionnaire/$questionnaireId/',
      path: '/questionnaire/$questionnaireId/',
      getParentRoute: () => LocaleUserIdProjectsProjectIdRouteRoute,
    } as any,
  )
const LocaleQuizPlayerProjectIdQuestionnairesQuestionnaireIdQuestionIdIndexRoute =
  LocaleQuizPlayerProjectIdQuestionnairesQuestionnaireIdQuestionIdIndexRouteImport.update(
    {
      id: '/questionnaires/$questionnaireId/$questionId/',
      path: '/questionnaires/$questionnaireId/$questionId/',
      getParentRoute: () => LocaleQuizPlayerProjectIdRouteRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/$locale': typeof LocaleRouteRouteWithChildren
  '/$locale/$userId': typeof LocaleUserIdRouteRouteWithChildren
  '/$locale/': typeof LocaleIndexRoute
  '/$locale/quiz-player/$projectId': typeof LocaleQuizPlayerProjectIdRouteRouteWithChildren
  '/$locale/forgot-password/': typeof LocaleForgotPasswordIndexRoute
  '/$locale/recovery/': typeof LocaleRecoveryIndexRoute
  '/$locale/signin/': typeof LocaleSigninIndexRoute
  '/$locale/signup/': typeof LocaleSignupIndexRoute
  '/$locale/verify-email/': typeof LocaleVerifyEmailIndexRoute
  '/$locale/$userId/projects/$projectId': typeof LocaleUserIdProjectsProjectIdRouteRouteWithChildren
  '/$locale/$userId/projects/': typeof LocaleUserIdProjectsIndexRoute
  '/$locale/exam/$token/': typeof LocaleExamTokenIndexRoute
  '/$locale/$userId/profile/certificates/': typeof LocaleUserIdProfileCertificatesIndexRoute
  '/$locale/$userId/profile/me/': typeof LocaleUserIdProfileMeIndexRoute
  '/$locale/$userId/profile/settings/': typeof LocaleUserIdProfileSettingsIndexRoute
  '/$locale/live/$sessionId/$teamId/': typeof LocaleLiveSessionIdTeamIdIndexRoute
  '/$locale/live/$sessionId/host/': typeof LocaleLiveSessionIdHostIndexRoute
  '/$locale/quiz-player/$projectId/questionnaires/': typeof LocaleQuizPlayerProjectIdQuestionnairesIndexRoute
  '/$locale/quiz-player/$projectId/welcome/': typeof LocaleQuizPlayerProjectIdWelcomeIndexRoute
  '/$locale/$userId/projects/$projectId/certificates/': typeof LocaleUserIdProjectsProjectIdCertificatesIndexRoute
  '/$locale/$userId/projects/$projectId/dashboard/': typeof LocaleUserIdProjectsProjectIdDashboardIndexRoute
  '/$locale/$userId/projects/$projectId/questionnaire/': typeof LocaleUserIdProjectsProjectIdQuestionnaireIndexRoute
  '/$locale/$userId/projects/$projectId/questions/': typeof LocaleUserIdProjectsProjectIdQuestionsIndexRoute
  '/$locale/$userId/projects/$projectId/settings/': typeof LocaleUserIdProjectsProjectIdSettingsIndexRoute
  '/$locale/quiz-player/$projectId/live/$sessionId/': typeof LocaleQuizPlayerProjectIdLiveSessionIdIndexRoute
  '/$locale/quiz-player/$projectId/questionnaires/$questionnaireId/': typeof LocaleQuizPlayerProjectIdQuestionnairesQuestionnaireIdIndexRoute
  '/$locale/$userId/projects/$projectId/questionnaire/$questionnaireId/': typeof LocaleUserIdProjectsProjectIdQuestionnaireQuestionnaireIdIndexRoute
  '/$locale/quiz-player/$projectId/questionnaires/$questionnaireId/$questionId/': typeof LocaleQuizPlayerProjectIdQuestionnairesQuestionnaireIdQuestionIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/$locale/$userId': typeof LocaleUserIdRouteRouteWithChildren
  '/$locale': typeof LocaleIndexRoute
  '/$locale/quiz-player/$projectId': typeof LocaleQuizPlayerProjectIdRouteRouteWithChildren
  '/$locale/forgot-password': typeof LocaleForgotPasswordIndexRoute
  '/$locale/recovery': typeof LocaleRecoveryIndexRoute
  '/$locale/signin': typeof LocaleSigninIndexRoute
  '/$locale/signup': typeof LocaleSignupIndexRoute
  '/$locale/verify-email': typeof LocaleVerifyEmailIndexRoute
  '/$locale/$userId/projects/$projectId': typeof LocaleUserIdProjectsProjectIdRouteRouteWithChildren
  '/$locale/$userId/projects': typeof LocaleUserIdProjectsIndexRoute
  '/$locale/exam/$token': typeof LocaleExamTokenIndexRoute
  '/$locale/$userId/profile/certificates': typeof LocaleUserIdProfileCertificatesIndexRoute
  '/$locale/$userId/profile/me': typeof LocaleUserIdProfileMeIndexRoute
  '/$locale/$userId/profile/settings': typeof LocaleUserIdProfileSettingsIndexRoute
  '/$locale/live/$sessionId/$teamId': typeof LocaleLiveSessionIdTeamIdIndexRoute
  '/$locale/live/$sessionId/host': typeof LocaleLiveSessionIdHostIndexRoute
  '/$locale/quiz-player/$projectId/questionnaires': typeof LocaleQuizPlayerProjectIdQuestionnairesIndexRoute
  '/$locale/quiz-player/$projectId/welcome': typeof LocaleQuizPlayerProjectIdWelcomeIndexRoute
  '/$locale/$userId/projects/$projectId/certificates': typeof LocaleUserIdProjectsProjectIdCertificatesIndexRoute
  '/$locale/$userId/projects/$projectId/dashboard': typeof LocaleUserIdProjectsProjectIdDashboardIndexRoute
  '/$locale/$userId/projects/$projectId/questionnaire': typeof LocaleUserIdProjectsProjectIdQuestionnaireIndexRoute
  '/$locale/$userId/projects/$projectId/questions': typeof LocaleUserIdProjectsProjectIdQuestionsIndexRoute
  '/$locale/$userId/projects/$projectId/settings': typeof LocaleUserIdProjectsProjectIdSettingsIndexRoute
  '/$locale/quiz-player/$projectId/live/$sessionId': typeof LocaleQuizPlayerProjectIdLiveSessionIdIndexRoute
  '/$locale/quiz-player/$projectId/questionnaires/$questionnaireId': typeof LocaleQuizPlayerProjectIdQuestionnairesQuestionnaireIdIndexRoute
  '/$locale/$userId/projects/$projectId/questionnaire/$questionnaireId': typeof LocaleUserIdProjectsProjectIdQuestionnaireQuestionnaireIdIndexRoute
  '/$locale/quiz-player/$projectId/questionnaires/$questionnaireId/$questionId': typeof LocaleQuizPlayerProjectIdQuestionnairesQuestionnaireIdQuestionIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/$locale': typeof LocaleRouteRouteWithChildren
  '/$locale/$userId': typeof LocaleUserIdRouteRouteWithChildren
  '/$locale/': typeof LocaleIndexRoute
  '/$locale/quiz-player/$projectId': typeof LocaleQuizPlayerProjectIdRouteRouteWithChildren
  '/$locale/forgot-password/': typeof LocaleForgotPasswordIndexRoute
  '/$locale/recovery/': typeof LocaleRecoveryIndexRoute
  '/$locale/signin/': typeof LocaleSigninIndexRoute
  '/$locale/signup/': typeof LocaleSignupIndexRoute
  '/$locale/verify-email/': typeof LocaleVerifyEmailIndexRoute
  '/$locale/$userId/projects/$projectId': typeof LocaleUserIdProjectsProjectIdRouteRouteWithChildren
  '/$locale/$userId/projects/': typeof LocaleUserIdProjectsIndexRoute
  '/$locale/exam/$token/': typeof LocaleExamTokenIndexRoute
  '/$locale/$userId/profile/certificates/': typeof LocaleUserIdProfileCertificatesIndexRoute
  '/$locale/$userId/profile/me/': typeof LocaleUserIdProfileMeIndexRoute
  '/$locale/$userId/profile/settings/': typeof LocaleUserIdProfileSettingsIndexRoute
  '/$locale/live/$sessionId/$teamId/': typeof LocaleLiveSessionIdTeamIdIndexRoute
  '/$locale/live/$sessionId/host/': typeof LocaleLiveSessionIdHostIndexRoute
  '/$locale/quiz-player/$projectId/questionnaires/': typeof LocaleQuizPlayerProjectIdQuestionnairesIndexRoute
  '/$locale/quiz-player/$projectId/welcome/': typeof LocaleQuizPlayerProjectIdWelcomeIndexRoute
  '/$locale/$userId/projects/$projectId/certificates/': typeof LocaleUserIdProjectsProjectIdCertificatesIndexRoute
  '/$locale/$userId/projects/$projectId/dashboard/': typeof LocaleUserIdProjectsProjectIdDashboardIndexRoute
  '/$locale/$userId/projects/$projectId/questionnaire/': typeof LocaleUserIdProjectsProjectIdQuestionnaireIndexRoute
  '/$locale/$userId/projects/$projectId/questions/': typeof LocaleUserIdProjectsProjectIdQuestionsIndexRoute
  '/$locale/$userId/projects/$projectId/settings/': typeof LocaleUserIdProjectsProjectIdSettingsIndexRoute
  '/$locale/quiz-player/$projectId/live/$sessionId/': typeof LocaleQuizPlayerProjectIdLiveSessionIdIndexRoute
  '/$locale/quiz-player/$projectId/questionnaires/$questionnaireId/': typeof LocaleQuizPlayerProjectIdQuestionnairesQuestionnaireIdIndexRoute
  '/$locale/$userId/projects/$projectId/questionnaire/$questionnaireId/': typeof LocaleUserIdProjectsProjectIdQuestionnaireQuestionnaireIdIndexRoute
  '/$locale/quiz-player/$projectId/questionnaires/$questionnaireId/$questionId/': typeof LocaleQuizPlayerProjectIdQuestionnairesQuestionnaireIdQuestionIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/$locale'
    | '/$locale/$userId'
    | '/$locale/'
    | '/$locale/quiz-player/$projectId'
    | '/$locale/forgot-password/'
    | '/$locale/recovery/'
    | '/$locale/signin/'
    | '/$locale/signup/'
    | '/$locale/verify-email/'
    | '/$locale/$userId/projects/$projectId'
    | '/$locale/$userId/projects/'
    | '/$locale/exam/$token/'
    | '/$locale/$userId/profile/certificates/'
    | '/$locale/$userId/profile/me/'
    | '/$locale/$userId/profile/settings/'
    | '/$locale/live/$sessionId/$teamId/'
    | '/$locale/live/$sessionId/host/'
    | '/$locale/quiz-player/$projectId/questionnaires/'
    | '/$locale/quiz-player/$projectId/welcome/'
    | '/$locale/$userId/projects/$projectId/certificates/'
    | '/$locale/$userId/projects/$projectId/dashboard/'
    | '/$locale/$userId/projects/$projectId/questionnaire/'
    | '/$locale/$userId/projects/$projectId/questions/'
    | '/$locale/$userId/projects/$projectId/settings/'
    | '/$locale/quiz-player/$projectId/live/$sessionId/'
    | '/$locale/quiz-player/$projectId/questionnaires/$questionnaireId/'
    | '/$locale/$userId/projects/$projectId/questionnaire/$questionnaireId/'
    | '/$locale/quiz-player/$projectId/questionnaires/$questionnaireId/$questionId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/$locale/$userId'
    | '/$locale'
    | '/$locale/quiz-player/$projectId'
    | '/$locale/forgot-password'
    | '/$locale/recovery'
    | '/$locale/signin'
    | '/$locale/signup'
    | '/$locale/verify-email'
    | '/$locale/$userId/projects/$projectId'
    | '/$locale/$userId/projects'
    | '/$locale/exam/$token'
    | '/$locale/$userId/profile/certificates'
    | '/$locale/$userId/profile/me'
    | '/$locale/$userId/profile/settings'
    | '/$locale/live/$sessionId/$teamId'
    | '/$locale/live/$sessionId/host'
    | '/$locale/quiz-player/$projectId/questionnaires'
    | '/$locale/quiz-player/$projectId/welcome'
    | '/$locale/$userId/projects/$projectId/certificates'
    | '/$locale/$userId/projects/$projectId/dashboard'
    | '/$locale/$userId/projects/$projectId/questionnaire'
    | '/$locale/$userId/projects/$projectId/questions'
    | '/$locale/$userId/projects/$projectId/settings'
    | '/$locale/quiz-player/$projectId/live/$sessionId'
    | '/$locale/quiz-player/$projectId/questionnaires/$questionnaireId'
    | '/$locale/$userId/projects/$projectId/questionnaire/$questionnaireId'
    | '/$locale/quiz-player/$projectId/questionnaires/$questionnaireId/$questionId'
  id:
    | '__root__'
    | '/'
    | '/$locale'
    | '/$locale/$userId'
    | '/$locale/'
    | '/$locale/quiz-player/$projectId'
    | '/$locale/forgot-password/'
    | '/$locale/recovery/'
    | '/$locale/signin/'
    | '/$locale/signup/'
    | '/$locale/verify-email/'
    | '/$locale/$userId/projects/$projectId'
    | '/$locale/$userId/projects/'
    | '/$locale/exam/$token/'
    | '/$locale/$userId/profile/certificates/'
    | '/$locale/$userId/profile/me/'
    | '/$locale/$userId/profile/settings/'
    | '/$locale/live/$sessionId/$teamId/'
    | '/$locale/live/$sessionId/host/'
    | '/$locale/quiz-player/$projectId/questionnaires/'
    | '/$locale/quiz-player/$projectId/welcome/'
    | '/$locale/$userId/projects/$projectId/certificates/'
    | '/$locale/$userId/projects/$projectId/dashboard/'
    | '/$locale/$userId/projects/$projectId/questionnaire/'
    | '/$locale/$userId/projects/$projectId/questions/'
    | '/$locale/$userId/projects/$projectId/settings/'
    | '/$locale/quiz-player/$projectId/live/$sessionId/'
    | '/$locale/quiz-player/$projectId/questionnaires/$questionnaireId/'
    | '/$locale/$userId/projects/$projectId/questionnaire/$questionnaireId/'
    | '/$locale/quiz-player/$projectId/questionnaires/$questionnaireId/$questionId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  LocaleRouteRoute: typeof LocaleRouteRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$locale': {
      id: '/$locale'
      path: '/$locale'
      fullPath: '/$locale'
      preLoaderRoute: typeof LocaleRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$locale/': {
      id: '/$locale/'
      path: '/'
      fullPath: '/$locale/'
      preLoaderRoute: typeof LocaleIndexRouteImport
      parentRoute: typeof LocaleRouteRoute
    }
    '/$locale/$userId': {
      id: '/$locale/$userId'
      path: '/$userId'
      fullPath: '/$locale/$userId'
      preLoaderRoute: typeof LocaleUserIdRouteRouteImport
      parentRoute: typeof LocaleRouteRoute
    }
    '/$locale/forgot-password/': {
      id: '/$locale/forgot-password/'
      path: '/forgot-password'
      fullPath: '/$locale/forgot-password/'
      preLoaderRoute: typeof LocaleForgotPasswordIndexRouteImport
      parentRoute: typeof LocaleRouteRoute
    }
    '/$locale/quiz-player/$projectId': {
      id: '/$locale/quiz-player/$projectId'
      path: '/quiz-player/$projectId'
      fullPath: '/$locale/quiz-player/$projectId'
      preLoaderRoute: typeof LocaleQuizPlayerProjectIdRouteRouteImport
      parentRoute: typeof LocaleRouteRoute
    }
    '/$locale/recovery/': {
      id: '/$locale/recovery/'
      path: '/recovery'
      fullPath: '/$locale/recovery/'
      preLoaderRoute: typeof LocaleRecoveryIndexRouteImport
      parentRoute: typeof LocaleRouteRoute
    }
    '/$locale/signin/': {
      id: '/$locale/signin/'
      path: '/signin'
      fullPath: '/$locale/signin/'
      preLoaderRoute: typeof LocaleSigninIndexRouteImport
      parentRoute: typeof LocaleRouteRoute
    }
    '/$locale/signup/': {
      id: '/$locale/signup/'
      path: '/signup'
      fullPath: '/$locale/signup/'
      preLoaderRoute: typeof LocaleSignupIndexRouteImport
      parentRoute: typeof LocaleRouteRoute
    }
    '/$locale/verify-email/': {
      id: '/$locale/verify-email/'
      path: '/verify-email'
      fullPath: '/$locale/verify-email/'
      preLoaderRoute: typeof LocaleVerifyEmailIndexRouteImport
      parentRoute: typeof LocaleRouteRoute
    }
    '/$locale/$userId/projects/': {
      id: '/$locale/$userId/projects/'
      path: '/projects'
      fullPath: '/$locale/$userId/projects/'
      preLoaderRoute: typeof LocaleUserIdProjectsIndexRouteImport
      parentRoute: typeof LocaleUserIdRouteRoute
    }
    '/$locale/$userId/projects/$projectId': {
      id: '/$locale/$userId/projects/$projectId'
      path: '/projects/$projectId'
      fullPath: '/$locale/$userId/projects/$projectId'
      preLoaderRoute: typeof LocaleUserIdProjectsProjectIdRouteRouteImport
      parentRoute: typeof LocaleUserIdRouteRoute
    }
    '/$locale/exam/$token/': {
      id: '/$locale/exam/$token/'
      path: '/exam/$token'
      fullPath: '/$locale/exam/$token/'
      preLoaderRoute: typeof LocaleExamTokenIndexRouteImport
      parentRoute: typeof LocaleRouteRoute
    }
    '/$locale/$userId/profile/certificates/': {
      id: '/$locale/$userId/profile/certificates/'
      path: '/profile/certificates'
      fullPath: '/$locale/$userId/profile/certificates/'
      preLoaderRoute: typeof LocaleUserIdProfileCertificatesIndexRouteImport
      parentRoute: typeof LocaleUserIdRouteRoute
    }
    '/$locale/$userId/profile/me/': {
      id: '/$locale/$userId/profile/me/'
      path: '/profile/me'
      fullPath: '/$locale/$userId/profile/me/'
      preLoaderRoute: typeof LocaleUserIdProfileMeIndexRouteImport
      parentRoute: typeof LocaleUserIdRouteRoute
    }
    '/$locale/$userId/profile/settings/': {
      id: '/$locale/$userId/profile/settings/'
      path: '/profile/settings'
      fullPath: '/$locale/$userId/profile/settings/'
      preLoaderRoute: typeof LocaleUserIdProfileSettingsIndexRouteImport
      parentRoute: typeof LocaleUserIdRouteRoute
    }
    '/$locale/live/$sessionId/$teamId/': {
      id: '/$locale/live/$sessionId/$teamId/'
      path: '/live/$sessionId/$teamId'
      fullPath: '/$locale/live/$sessionId/$teamId/'
      preLoaderRoute: typeof LocaleLiveSessionIdTeamIdIndexRouteImport
      parentRoute: typeof LocaleRouteRoute
    }
    '/$locale/live/$sessionId/host/': {
      id: '/$locale/live/$sessionId/host/'
      path: '/live/$sessionId/host'
      fullPath: '/$locale/live/$sessionId/host/'
      preLoaderRoute: typeof LocaleLiveSessionIdHostIndexRouteImport
      parentRoute: typeof LocaleRouteRoute
    }
    '/$locale/quiz-player/$projectId/questionnaires/': {
      id: '/$locale/quiz-player/$projectId/questionnaires/'
      path: '/questionnaires'
      fullPath: '/$locale/quiz-player/$projectId/questionnaires/'
      preLoaderRoute: typeof LocaleQuizPlayerProjectIdQuestionnairesIndexRouteImport
      parentRoute: typeof LocaleQuizPlayerProjectIdRouteRoute
    }
    '/$locale/quiz-player/$projectId/welcome/': {
      id: '/$locale/quiz-player/$projectId/welcome/'
      path: '/welcome'
      fullPath: '/$locale/quiz-player/$projectId/welcome/'
      preLoaderRoute: typeof LocaleQuizPlayerProjectIdWelcomeIndexRouteImport
      parentRoute: typeof LocaleQuizPlayerProjectIdRouteRoute
    }
    '/$locale/$userId/projects/$projectId/certificates/': {
      id: '/$locale/$userId/projects/$projectId/certificates/'
      path: '/certificates'
      fullPath: '/$locale/$userId/projects/$projectId/certificates/'
      preLoaderRoute: typeof LocaleUserIdProjectsProjectIdCertificatesIndexRouteImport
      parentRoute: typeof LocaleUserIdProjectsProjectIdRouteRoute
    }
    '/$locale/$userId/projects/$projectId/dashboard/': {
      id: '/$locale/$userId/projects/$projectId/dashboard/'
      path: '/dashboard'
      fullPath: '/$locale/$userId/projects/$projectId/dashboard/'
      preLoaderRoute: typeof LocaleUserIdProjectsProjectIdDashboardIndexRouteImport
      parentRoute: typeof LocaleUserIdProjectsProjectIdRouteRoute
    }
    '/$locale/$userId/projects/$projectId/questionnaire/': {
      id: '/$locale/$userId/projects/$projectId/questionnaire/'
      path: '/questionnaire'
      fullPath: '/$locale/$userId/projects/$projectId/questionnaire/'
      preLoaderRoute: typeof LocaleUserIdProjectsProjectIdQuestionnaireIndexRouteImport
      parentRoute: typeof LocaleUserIdProjectsProjectIdRouteRoute
    }
    '/$locale/$userId/projects/$projectId/questions/': {
      id: '/$locale/$userId/projects/$projectId/questions/'
      path: '/questions'
      fullPath: '/$locale/$userId/projects/$projectId/questions/'
      preLoaderRoute: typeof LocaleUserIdProjectsProjectIdQuestionsIndexRouteImport
      parentRoute: typeof LocaleUserIdProjectsProjectIdRouteRoute
    }
    '/$locale/$userId/projects/$projectId/settings/': {
      id: '/$locale/$userId/projects/$projectId/settings/'
      path: '/settings'
      fullPath: '/$locale/$userId/projects/$projectId/settings/'
      preLoaderRoute: typeof LocaleUserIdProjectsProjectIdSettingsIndexRouteImport
      parentRoute: typeof LocaleUserIdProjectsProjectIdRouteRoute
    }
    '/$locale/quiz-player/$projectId/live/$sessionId/': {
      id: '/$locale/quiz-player/$projectId/live/$sessionId/'
      path: '/live/$sessionId'
      fullPath: '/$locale/quiz-player/$projectId/live/$sessionId/'
      preLoaderRoute: typeof LocaleQuizPlayerProjectIdLiveSessionIdIndexRouteImport
      parentRoute: typeof LocaleQuizPlayerProjectIdRouteRoute
    }
    '/$locale/quiz-player/$projectId/questionnaires/$questionnaireId/': {
      id: '/$locale/quiz-player/$projectId/questionnaires/$questionnaireId/'
      path: '/questionnaires/$questionnaireId'
      fullPath: '/$locale/quiz-player/$projectId/questionnaires/$questionnaireId/'
      preLoaderRoute: typeof LocaleQuizPlayerProjectIdQuestionnairesQuestionnaireIdIndexRouteImport
      parentRoute: typeof LocaleQuizPlayerProjectIdRouteRoute
    }
    '/$locale/$userId/projects/$projectId/questionnaire/$questionnaireId/': {
      id: '/$locale/$userId/projects/$projectId/questionnaire/$questionnaireId/'
      path: '/questionnaire/$questionnaireId'
      fullPath: '/$locale/$userId/projects/$projectId/questionnaire/$questionnaireId/'
      preLoaderRoute: typeof LocaleUserIdProjectsProjectIdQuestionnaireQuestionnaireIdIndexRouteImport
      parentRoute: typeof LocaleUserIdProjectsProjectIdRouteRoute
    }
    '/$locale/quiz-player/$projectId/questionnaires/$questionnaireId/$questionId/': {
      id: '/$locale/quiz-player/$projectId/questionnaires/$questionnaireId/$questionId/'
      path: '/questionnaires/$questionnaireId/$questionId'
      fullPath: '/$locale/quiz-player/$projectId/questionnaires/$questionnaireId/$questionId/'
      preLoaderRoute: typeof LocaleQuizPlayerProjectIdQuestionnairesQuestionnaireIdQuestionIdIndexRouteImport
      parentRoute: typeof LocaleQuizPlayerProjectIdRouteRoute
    }
  }
}

interface LocaleUserIdProjectsProjectIdRouteRouteChildren {
  LocaleUserIdProjectsProjectIdCertificatesIndexRoute: typeof LocaleUserIdProjectsProjectIdCertificatesIndexRoute
  LocaleUserIdProjectsProjectIdDashboardIndexRoute: typeof LocaleUserIdProjectsProjectIdDashboardIndexRoute
  LocaleUserIdProjectsProjectIdQuestionnaireIndexRoute: typeof LocaleUserIdProjectsProjectIdQuestionnaireIndexRoute
  LocaleUserIdProjectsProjectIdQuestionsIndexRoute: typeof LocaleUserIdProjectsProjectIdQuestionsIndexRoute
  LocaleUserIdProjectsProjectIdSettingsIndexRoute: typeof LocaleUserIdProjectsProjectIdSettingsIndexRoute
  LocaleUserIdProjectsProjectIdQuestionnaireQuestionnaireIdIndexRoute: typeof LocaleUserIdProjectsProjectIdQuestionnaireQuestionnaireIdIndexRoute
}

const LocaleUserIdProjectsProjectIdRouteRouteChildren: LocaleUserIdProjectsProjectIdRouteRouteChildren =
  {
    LocaleUserIdProjectsProjectIdCertificatesIndexRoute:
      LocaleUserIdProjectsProjectIdCertificatesIndexRoute,
    LocaleUserIdProjectsProjectIdDashboardIndexRoute:
      LocaleUserIdProjectsProjectIdDashboardIndexRoute,
    LocaleUserIdProjectsProjectIdQuestionnaireIndexRoute:
      LocaleUserIdProjectsProjectIdQuestionnaireIndexRoute,
    LocaleUserIdProjectsProjectIdQuestionsIndexRoute:
      LocaleUserIdProjectsProjectIdQuestionsIndexRoute,
    LocaleUserIdProjectsProjectIdSettingsIndexRoute:
      LocaleUserIdProjectsProjectIdSettingsIndexRoute,
    LocaleUserIdProjectsProjectIdQuestionnaireQuestionnaireIdIndexRoute:
      LocaleUserIdProjectsProjectIdQuestionnaireQuestionnaireIdIndexRoute,
  }

const LocaleUserIdProjectsProjectIdRouteRouteWithChildren =
  LocaleUserIdProjectsProjectIdRouteRoute._addFileChildren(
    LocaleUserIdProjectsProjectIdRouteRouteChildren,
  )

interface LocaleUserIdRouteRouteChildren {
  LocaleUserIdProjectsProjectIdRouteRoute: typeof LocaleUserIdProjectsProjectIdRouteRouteWithChildren
  LocaleUserIdProjectsIndexRoute: typeof LocaleUserIdProjectsIndexRoute
  LocaleUserIdProfileCertificatesIndexRoute: typeof LocaleUserIdProfileCertificatesIndexRoute
  LocaleUserIdProfileMeIndexRoute: typeof LocaleUserIdProfileMeIndexRoute
  LocaleUserIdProfileSettingsIndexRoute: typeof LocaleUserIdProfileSettingsIndexRoute
}

const LocaleUserIdRouteRouteChildren: LocaleUserIdRouteRouteChildren = {
  LocaleUserIdProjectsProjectIdRouteRoute:
    LocaleUserIdProjectsProjectIdRouteRouteWithChildren,
  LocaleUserIdProjectsIndexRoute: LocaleUserIdProjectsIndexRoute,
  LocaleUserIdProfileCertificatesIndexRoute:
    LocaleUserIdProfileCertificatesIndexRoute,
  LocaleUserIdProfileMeIndexRoute: LocaleUserIdProfileMeIndexRoute,
  LocaleUserIdProfileSettingsIndexRoute: LocaleUserIdProfileSettingsIndexRoute,
}

const LocaleUserIdRouteRouteWithChildren =
  LocaleUserIdRouteRoute._addFileChildren(LocaleUserIdRouteRouteChildren)

interface LocaleQuizPlayerProjectIdRouteRouteChildren {
  LocaleQuizPlayerProjectIdQuestionnairesIndexRoute: typeof LocaleQuizPlayerProjectIdQuestionnairesIndexRoute
  LocaleQuizPlayerProjectIdWelcomeIndexRoute: typeof LocaleQuizPlayerProjectIdWelcomeIndexRoute
  LocaleQuizPlayerProjectIdLiveSessionIdIndexRoute: typeof LocaleQuizPlayerProjectIdLiveSessionIdIndexRoute
  LocaleQuizPlayerProjectIdQuestionnairesQuestionnaireIdIndexRoute: typeof LocaleQuizPlayerProjectIdQuestionnairesQuestionnaireIdIndexRoute
  LocaleQuizPlayerProjectIdQuestionnairesQuestionnaireIdQuestionIdIndexRoute: typeof LocaleQuizPlayerProjectIdQuestionnairesQuestionnaireIdQuestionIdIndexRoute
}

const LocaleQuizPlayerProjectIdRouteRouteChildren: LocaleQuizPlayerProjectIdRouteRouteChildren =
  {
    LocaleQuizPlayerProjectIdQuestionnairesIndexRoute:
      LocaleQuizPlayerProjectIdQuestionnairesIndexRoute,
    LocaleQuizPlayerProjectIdWelcomeIndexRoute:
      LocaleQuizPlayerProjectIdWelcomeIndexRoute,
    LocaleQuizPlayerProjectIdLiveSessionIdIndexRoute:
      LocaleQuizPlayerProjectIdLiveSessionIdIndexRoute,
    LocaleQuizPlayerProjectIdQuestionnairesQuestionnaireIdIndexRoute:
      LocaleQuizPlayerProjectIdQuestionnairesQuestionnaireIdIndexRoute,
    LocaleQuizPlayerProjectIdQuestionnairesQuestionnaireIdQuestionIdIndexRoute:
      LocaleQuizPlayerProjectIdQuestionnairesQuestionnaireIdQuestionIdIndexRoute,
  }

const LocaleQuizPlayerProjectIdRouteRouteWithChildren =
  LocaleQuizPlayerProjectIdRouteRoute._addFileChildren(
    LocaleQuizPlayerProjectIdRouteRouteChildren,
  )

interface LocaleRouteRouteChildren {
  LocaleUserIdRouteRoute: typeof LocaleUserIdRouteRouteWithChildren
  LocaleIndexRoute: typeof LocaleIndexRoute
  LocaleQuizPlayerProjectIdRouteRoute: typeof LocaleQuizPlayerProjectIdRouteRouteWithChildren
  LocaleForgotPasswordIndexRoute: typeof LocaleForgotPasswordIndexRoute
  LocaleRecoveryIndexRoute: typeof LocaleRecoveryIndexRoute
  LocaleSigninIndexRoute: typeof LocaleSigninIndexRoute
  LocaleSignupIndexRoute: typeof LocaleSignupIndexRoute
  LocaleVerifyEmailIndexRoute: typeof LocaleVerifyEmailIndexRoute
  LocaleExamTokenIndexRoute: typeof LocaleExamTokenIndexRoute
  LocaleLiveSessionIdTeamIdIndexRoute: typeof LocaleLiveSessionIdTeamIdIndexRoute
  LocaleLiveSessionIdHostIndexRoute: typeof LocaleLiveSessionIdHostIndexRoute
}

const LocaleRouteRouteChildren: LocaleRouteRouteChildren = {
  LocaleUserIdRouteRoute: LocaleUserIdRouteRouteWithChildren,
  LocaleIndexRoute: LocaleIndexRoute,
  LocaleQuizPlayerProjectIdRouteRoute:
    LocaleQuizPlayerProjectIdRouteRouteWithChildren,
  LocaleForgotPasswordIndexRoute: LocaleForgotPasswordIndexRoute,
  LocaleRecoveryIndexRoute: LocaleRecoveryIndexRoute,
  LocaleSigninIndexRoute: LocaleSigninIndexRoute,
  LocaleSignupIndexRoute: LocaleSignupIndexRoute,
  LocaleVerifyEmailIndexRoute: LocaleVerifyEmailIndexRoute,
  LocaleExamTokenIndexRoute: LocaleExamTokenIndexRoute,
  LocaleLiveSessionIdTeamIdIndexRoute: LocaleLiveSessionIdTeamIdIndexRoute,
  LocaleLiveSessionIdHostIndexRoute: LocaleLiveSessionIdHostIndexRoute,
}

const LocaleRouteRouteWithChildren = LocaleRouteRoute._addFileChildren(
  LocaleRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  LocaleRouteRoute: LocaleRouteRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
